import { useLocation, useNavigate } from "react-router-dom";
import qs from "qs";
import { IFilters } from "../utils/types";

export interface applyUrlFiltersFunction {
  (newFilters: IFilters): void;
}

function useUrlFilters() {
  const navigate = useNavigate();
  const location = useLocation();

  const parseUrlFilters = () => {
    const queryParams =
      qs.parse(location.search, { ignoreQueryPrefix: true, depth: 3 }) ?? {};
    return (
      (queryParams.filters as Record<
        string,
        { value: any; column: string; operator: string }
      >) || {}
    );
  };

  const applyUrlFilters: applyUrlFiltersFunction = (newFilters) => {
    const currentQuery = qs.parse(location.search, { ignoreQueryPrefix: true });
    const { filters, ...remainingQuery } = currentQuery;

    const updatedQuery = {
      ...remainingQuery,
      filters: newFilters,
    };
    const queryString = qs.stringify(updatedQuery, { encode: true });
    navigate({
      pathname: location.pathname,
      search: `?${queryString}`,
    });
  };

  const getFilterValue = (column: string): string | undefined => {
    const filters = parseUrlFilters();
    return filters[column]?.value;
  };

  const getFilterOperator = (column: string): string | undefined => {
    const filters = parseUrlFilters();
    return filters[column]?.operator;
  };

  return {
    applyUrlFilters,
    parseUrlFilters,
    getFilterValue,
    getFilterOperator
  };
}

export default useUrlFilters;
